import { useSelector } from "react-redux";
import {
  CircularProgress,
} from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";


const approvalOptions = {
  "Submitted": 0,
  "State Officer Approved": 1,
  "State Officer Rejected": 2,
  "State Cord. Approved": 3,
  "State Cord. Rejected": 4,
  "HQ Approved": 5,
  "HQ Rejected": 6,
  "Physical Ver. Approved": 7,
  "Physical Ver. Rejected": 8
}

function parseApprovalOptions(options) {
  let parsedApprovalOptions = []

  const approvalTexts = Object.keys(options)

  approvalTexts.map(text => {
    const parsedModel = {
      value: options[text],
      label: text
    }

    parsedApprovalOptions.push(parsedModel)
    return null;
  })

  return parsedApprovalOptions
}

export const filterOptions = [
  {
    type: "radio",
    name: "Status",
    group: "Status",
    options: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Active",
        value: true,
      },
      {
        label: "Inactive",
        value: false,
      },
    ],
  },
  {
    type: "dropdown",
    name: "ApprovalStatus",
    group: "Approval Status",
    label: "Approval Status",
    options: parseApprovalOptions(approvalOptions),
  },
];

export const DownloadIcon = () => {
  const trainersStore = (state) => state.trainersReducer;

  const { exportingTrainersReport } = useSelector(trainersStore);

  if (exportingTrainersReport) {
    return <CircularProgress size={20} />;
  } else {
    return <CloudDownloadOutlinedIcon />;
  }
};